import React from 'react';
import { useSelector } from 'react-redux';
import { Grid } from 'semantic-ui-react';

import { AppState } from 'services/types';
import WarningMessage from 'components/WarningMessage';
import {
    FertilizerProductPerUnitType,
    FertilizerProductId
} from 'services/fertilizerEvents/types';
import { EntityId } from 'services/entities/types';

import { selectEntitiesHaveNumberOfTrees } from '../../../../selectors';

export interface Props {
    productId: FertilizerProductId | null;
    entityIds: EntityId[];
    perUnitType: FertilizerProductPerUnitType;
}

const WARNING_CONTENT =
    'This can affect the product total amount, but the rate per-tree is still applicable';

export default function FertilizerEventNumberOfTreesWarning(
    props: Props
): React.ReactElement | null {
    const { entityIds, productId, perUnitType } = props;

    const hasNumberOfTreesOnAllEntities = useSelector((state: AppState) =>
        selectEntitiesHaveNumberOfTrees(state, props)
    );

    if (hasNumberOfTreesOnAllEntities || perUnitType === 'Ha') return null;

    return (
        <Grid.Row>
            <Grid.Column>
                <WarningMessage
                    title="Some areas do not have number of trees defined"
                    content={WARNING_CONTENT}
                    visible={!!productId}
                />
            </Grid.Column>
        </Grid.Row>
    );
}
